import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import TreatmentsCalendarViewBody from "components/ClinicalManagement/Treatments/TreatmentsCalendarViewBody";

const Treatments = () => {
  useEffect(() => {
    document.title = "Treatments";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <TreatmentsCalendarViewBody />
    </main>
  );
};

export default Treatments;
